import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Autoplay, Pagination]);

export default class SwiperSlideshow {
  constructor(element, type) {
    this.element = element;
    this.type = type;
    this.init();
  }

  init() {
    if (this.type === 'caroussel') {
      this.setupCarousselSwiper();
    }
    if (this.type === 'instagram') {
      this.setupInstagramSwiper();
    }
    if (this.type === 'match') {
      this.setupMatchSwiper();
    }
  }

  setupCarousselSwiper() {
    // eslint-disable-next-line

    const swiperEl = this.element;
    if (swiperEl) {
      const swiperElSlides = swiperEl.querySelectorAll('.swiper-slide');
      if (swiperElSlides.length > 1) {
        // eslint-disable-next-line
        const swiper = new Swiper(swiperEl, {
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
          },
          mobileFirst: true,
          loop: true,
          speed: 1000,
          slidesPerView: 1,
          spaceBetween: 0,
          watchOverflow: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }
    }
  }

  setupMatchSwiper() {
    // eslint-disable-next-line

    const swiperEl = this.element;
    if (swiperEl) {
      const swiperElSlides = swiperEl.querySelectorAll('.swiper-slide');
      if (swiperElSlides.length > 1) {
        // eslint-disable-next-line
        const swiper = new Swiper(swiperEl, {
          direction: 'horizontal',
          centeredSlides: false,
          preloadImages: true,
          loop: false,
          spaceBetween: 20,
          updateOnImagesReady: true,
          slidesPerView: 1.8,
          effect: 'fade',
          a11y: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            768: {
              slidesPerView: 2.4,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 3.4,
              spaceBetween: 20,
            },
          },
        });
      }
    }
  }

  setupInstagramSwiper() {
    // eslint-disable-next-line
    const swiperEl = this.element;
    if (swiperEl) {
      const swiperElSlides = swiperEl.querySelectorAll('.swiper-slide');
      if (swiperElSlides.length > 1) {
        // eslint-disable-next-line
        const swiper = new Swiper(swiperEl, {
          speed: 600,
          slidesPerView: 2,
          spaceBetween: 10,
          mobileFirst: true,
          /*  watchOverflow: true,
          observer: true,
          observeParents: true, */
          navigation: {
            nextEl: swiperEl.querySelector('.swiper-button-next'),
            prevEl: swiperEl.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            768: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 5,
            },
          },
        });
      }
    }
  }
}
